import script from "./Sidebar_Management_Component.vue?vue&type=script&setup=true&lang=js"
export * from "./Sidebar_Management_Component.vue?vue&type=script&setup=true&lang=js"

import "./Sidebar_Management_Component.vue?vue&type=style&index=0&id=36baaca8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36baaca8"]])

export default __exports__